<template>
  <v-dialog
    v-model="dialog"
    transition="slide-y-reverse-transition"
    overlay-color="black"
    content-class="booking-modal"
    persistent
  >
    <Overlay
      :visible="overlay"
      overlay-message="Booking your appointment with a Virtual House Pro"
    />

    <template v-slot:activator="{ on }">
      <v-btn
        color="primary secondary--text elevation-0"
        block
        dark
        v-on="on"
        @click="e1 = 1"
        :disabled="currentSlot.booked"
        >Book This Time</v-btn
      >
    </template>

    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Your Info</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">Details</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">Payment</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <form data-vv-scope="form1">
            <v-card class="mb-0" elevation="0">
              <v-alert
                class="mb-5"
                border="left"
                colored-border
                color="success accent-4"
                elevation="2"
              >
                <div class="title">You're booking for:</div>
                {{ selectedDateAndTime }}
                <base-text>Central Time</base-text>
              </v-alert>
              <span
                class="invalid-feedback"
                v-if="
                  hasErrors &&
                  fields.$form1 &&
                  fields.$form1.name &&
                  fields.$form1.name.valid === false
                "
                >The name field is required.</span
              >
              <v-text-field
                outlined
                name="name"
                label="Your Name"
                v-model="formData.name"
                v-validate="'required'"
                class="mb-0"
                color="black darken-2"
              ></v-text-field>
              <span
                class="invalid-feedback"
                v-if="
                  hasErrors &&
                  fields.$form1 &&
                  fields.$form1.name &&
                  fields.$form1.email.valid === false
                "
                >The email field is required.</span
              >
              <v-text-field
                outlined
                name="email"
                label="Your Email Address"
                v-model="formData.contactEmail"
                v-validate="'required'"
                color="black darken-2"
              ></v-text-field>

              <span
                class="invalid-feedback"
                v-if="
                  hasErrors &&
                  fields.$form1 &&
                  fields.$form1.name &&
                  fields.$form1.email &&
                  fields.$form1.phone.valid === false
                "
                >The phone number field is required.</span
              >
              <v-text-field
                outlined
                persistent-hint
                type="tel"
                name="phone"
                label="Your Phone Number"
                v-model="formData.phoneNumber"
                v-validate="'required'"
                color="black darken-2"
                hint="We need your phone number for Facetime calls and also to contact you if we need to adjust details around your Virtual House Pro call.  We will not use your phone number in any other way."
              ></v-text-field>
            </v-card>
          </form>
        </v-stepper-content>

        <v-stepper-content step="2">
          <form data-vv-scope="form2">
            <v-card class="mb-0" elevation="0">
              <v-select
                outlined
                name="chat"
                :items="items"
                label="Video Chat Service"
                v-model="formData.chatPreference"
                v-validate="'required'"
                persistent-hint
                hint="Choose the service you would like to video call through."
                color="black darken-2"
              ></v-select>
              <span
                class="invalid-feedback"
                v-if="
                  hasErrors &&
                  fields.$form2 &&
                  fields.$form2.chat &&
                  fields.$form2.chat.valid === false
                "
                >The chat field is required.</span
              >
              <v-card-subtitle class="service-subtitle mt-2"
                >How can we help you?</v-card-subtitle
              >
              <v-radio-group
                name="service"
                v-validate="'required'"
                v-model="formData.service"
                class="mt-0"
              >
                <v-radio
                  label="Get a Quote for a home project"
                  value="quote"
                ></v-radio>
                <v-radio
                  label="Need Advice on a DIY project"
                  value="advice"
                ></v-radio>
                <v-radio
                  label="Estimate or Pre-estimate"
                  value="estimate"
                ></v-radio>
                <v-radio
                  label="Let's talk design process"
                  value="design"
                ></v-radio>
              </v-radio-group>
              <span
                class="invalid-feedback"
                v-if="
                  hasErrors &&
                  fields.$form2 &&
                  fields.$form2.service &&
                  fields.$form2.service.valid === false
                "
                >The service field is required.</span
              >
              <v-textarea
                persistent-hint
                outlined
                name="detail"
                label="What would you like to accomplish on the call?"
                hint="Give more info about the quote, estimate or advice you need"
                v-model="formData.details"
                v-validate="'required'"
                color="black darken-2"
              ></v-textarea>
              <span
                class="invalid-feedback"
                v-if="
                  hasErrors &&
                  fields.$form2 &&
                  fields.$form2.detail &&
                  fields.$form2.detail.valid === false
                "
                >The detail field is required.</span
              >
            </v-card>
          </form>
        </v-stepper-content>

        <v-stepper-content step="3" class="text-center">
          <p class="text-center">Redirecting you to payment...</p>
          <v-progress-circular
            :size="70"
            :width="7"
            color="green"
            indeterminate
          ></v-progress-circular>
        </v-stepper-content>

        <div class="px-4 pb-4 d-flex justify-space-between align-center">
          <v-btn small text @click="backButton" v-if="e1 < 3">
            <v-icon left>mdi-chevron-left</v-icon>
            {{ goBackText }}
          </v-btn>
          <v-btn
            v-if="e1 < 3"
            @click="validateStep"
            color="primary secondary--text"
            class="float-right"
          >
            Next
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { db } from "../firebase/firebase";
import UtilsMixin from "../mixins/UtilsMixin";
import Overlay from "./Overlay";
import BaseText from "./base/Text";

export default {
  name: "BookingModal",
  mixins: [UtilsMixin],
  components: {
    Overlay,
    BaseText,
  },
  props: {
    selectedDateAndTime: {
      type: String,
      required: true,
    },
    currentSlot: {
      required: true,
    },
    slotIndex: {
      required: true,
    },
    day: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      e1: 1,
      dialog: false,
      items: ["Facetime", "Zoom"],
      formData: {},
      formStatus: "",
      overlay: false,
      hasErrors: false,
    };
  },
  firestore() {
    return {
      users: db.collection("users"),
      calEvent: db.collection("calEvent"),
    };
  },
  computed: {
    goBackText() {
      return this.e1 == 1 ? "Cancel" : "Go Back";
    },
    itemCost() {
      // cost in cents
      return 7500;
    },
    stripeURI() {
      return process.env.NODE_ENV === "development"
        ? `${this.localBase}/createStripeSession`
        : `${this.prodBase}/createStripeSession`;
    },
    stripePublicKey() {
      return process.env.NODE_ENV === "development"
        ? "pk_test_51H26VQCH84pxID7cD4xkVEndqB4k4BuJl4xLfeIymDDGLt2AwzIRikEk3GuLgxH7GnUbvVA52KvUln9imYDqPAVf00Y24V9tnF"
        : "pk_live_51H26VQCH84pxID7c8Rq5vOexsVsMLHSGg81oTZ3uI5zVkzhnSwrHq3Zm6ExGiPI44MV2zq0Xm0FI2cQ36hmp3dfM00zo4lH6f5";
    },
  },
  methods: {
    async sendEmailCloudFunction(formData, last4, brand, charge, date) {
      try {
        const response = await axios.post(this.sendEmailURI, {
          formData,
          last4,
          brand,
          charge,
          date,
        });
        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    async sendEmailToMattCloudFunction(formData, date) {
      try {
        const response = await axios.post(this.sendEmailToMattURI, {
          formData,
          date,
        });
        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    sendEmail(payload) {
      this.sendEmailCloudFunction(
        this.formData,
        payload.last4,
        payload.brand,
        payload.charge,
        this.selectedDateAndTime
      );
    },
    sendEmailToMatt() {
      this.sendEmailToMattCloudFunction(
        this.formData,
        this.selectedDateAndTime
      );
    },
    redirectToStripeCheckout() {
      const email = this.formData.contactEmail;

      fetch(this.stripeURI, {
        method: "POST",
        body: email,
      })
        .then((response) => {
          return response.json();
        })
        .then((session) => {
          return this.stripe.redirectToCheckout({ sessionId: session.id });
        })
        .then((result) => {
          // If `redirectToCheckout` fails due to a browser or network
          // error, you should display the localized error message to your
          // customer using `error.message`.
          if (result.error) {
            alert(result.error.message);
            setTimeout(() => (this.e1 = 2), 500);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setTimeout(() => {
            this.e1 = 2;
            this.$emit("snackbarError", true);
          }, 500);
        });
    },
    init() {
      this.stripe = window.Stripe(this.stripePublicKey);
    },
    backButton() {
      if (this.e1 > 1) {
        this.e1--;
        this.backText = "Go Back";
      } else {
        this.dialog = false;
        this.backText = "Cancel";
      }
    },
    triggerOverlay() {
      this.overlay = true;
    },
    validateStep() {
      const scope = `form${this.e1}`;

      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.hasErrors = false;
          this.e1++;
        } else {
          this.hasErrors = true;
        }
      });
    },
    extractFormKeysAndFormat(item) {
      const [key] = Object.entries(this.formData).find((i) => i[1] === item);
      return `${key}: ${item}`;
    },
    holdAppointment() {
      this.$store.commit("setBookingDetails", {
        slot: this.currentSlot,
        index: this.slotIndex,
        formData: this.formData,
        day: this.day,
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    dialog() {
      // clear formData and errors on dialog action
      this.formData = {};
      this.errors.clear();
      this.hasErrors = false;
    },
    e1() {
      if (this.e1 === 3) {
        this.holdAppointment();
        this.redirectToStripeCheckout();
      }
    },
  },
  created() {
    if (this.userEmail) {
      this.formData.contactEmail = this.userEmail;
    }
  },
};
</script>

<style lang="scss">
.invalid-feedback {
  color: red;
}

.v-stepper__content {
  padding-left: 15px;
  padding-right: 15px;
}

.v-card {
  box-shadow: none;

  .v-subheader {
    padding: 0;
  }

  .v-list-item {
    padding: 0;
  }
}

.booking-modal {
  @media (min-width: 768px) {
    max-width: 650px;
  }
}

.service-subtitle {
  padding: 0;
  font-weight: bold;
  color: black;
}
</style>
